import { gql } from '@apollo/client'

export const GET_CHANNEL_DRAFTS = gql`
  query GetChannelDrafts($channelId: ID!) {
    channelDrafts(channelId: $channelId) {
      id
      text
      status
      publishedAt
    }
  }
`
